export const isAddYours = buzz => buzz.tags.includes('--add-yours');
